import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { deleteInfluencerChannel } from 'scenes/Influencers/InfluencersChannels/sources/influencersChannels';

import { remove, details } from '../queryKeyFactory';

export const useDeleteInfluencerChannel = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const removeMutation = useMutation(remove(), deleteInfluencerChannel, {
    successMessage: () => `Influencer Channel deleted`,
    refreshOptions: {
      withoutQueryKey: ({ id }) => details(id),
    },
  });

  const handleAction = async ({ id, name }) => {
    await showModal({
      title: 'Delete Influencer Channel?',
      confirmActionLabel: 'Delete',
      bodyText: `«${name}»`,
    });
    await removeMutation.mutateAsync({ id });
  };

  return [handleAction, removeMutation];
};
